class RepeatOptions {
    constructor() {
        this.values = [300, 600, 900, 1200, 1800, 2700, 3600, 7200, 10800, 21600, 43200, 86400, 604800, 2419200];
    }
    getValues() {
        return this.values;
    }
}
export default new RepeatOptions();
